import { render, staticRenderFns } from "./PandaVideo.vue?vue&type=template&id=f56cf816&scoped=true&"
import script from "./PandaVideo.vue?vue&type=script&lang=js&"
export * from "./PandaVideo.vue?vue&type=script&lang=js&"
import style0 from "./PandaVideo.vue?vue&type=style&index=0&id=f56cf816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56cf816",
  null
  
)

export default component.exports